import React from 'react';

export default function Maintenance() {
  return (
    <div className="mt-28 flex min-h-full w-full flex-col justify-center bg-gray-100 dark:bg-stone-700">
      <div className="relative py-3 sm:mx-auto sm:max-w-xl">
        <div className="absolute inset-0 -skew-y-6 transform bg-gradient-to-r from-indigo-400 to-indigo-600 shadow-lg sm:-rotate-6 sm:skew-y-0 sm:rounded-3xl"></div>
        <div className="relative bg-white px-4 py-10 shadow-lg dark:bg-stone-800 sm:rounded-3xl sm:p-20">
          <div className="mx-auto max-w-full">
            <div>
              <h1 className="text-2xl font-semibold dark:text-gray-100">
                Under maintenance
              </h1>
            </div>
            <div className="divide-y divide-gray-200 dark:divide-gray-400">
              <div className="space-y-4 py-8 text-base leading-6 text-gray-700 dark:text-gray-200 sm:text-lg sm:leading-7">
                <p>
                  We apologize for the inconvenience, but our website is
                  currently undergoing scheduled maintenance. We are working
                  hard to improve our site's functionality and enhance your
                  experience. Please check back soon!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
